import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c(VSubheader, { staticClass: "text--black subtitle-1" }, [
        _vm._v(_vm._s(_vm.$t("descripcion.see_request_detail"))),
      ]),
      _c(
        VForm,
        { ref: "form", staticClass: "form mt-2" },
        [
          _c(
            VRow,
            { attrs: { dense: "" } },
            [
              _c(
                VCol,
                { attrs: { cols: "3", lg: "2" } },
                [
                  _c(VSubheader, { staticClass: "font-weight-bold" }, [
                    _vm._v(_vm._s(_vm.$t("form_attrs_use_case.organization"))),
                  ]),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "9", lg: "4" } },
                [
                  _c(VTextField, {
                    attrs: {
                      filled: "",
                      readonly: "",
                      "hide-details": "auto",
                      dense: "",
                    },
                    model: {
                      value: _vm.useCase.organization,
                      callback: function ($$v) {
                        _vm.$set(_vm.useCase, "organization", $$v)
                      },
                      expression: "useCase.organization",
                    },
                  }),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "3", lg: "2" } },
                [
                  _c(VSubheader, { staticClass: "font-weight-bold" }, [
                    _vm._v(
                      _vm._s(_vm.$t("form_attrs_use_case.expiration_date"))
                    ),
                  ]),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "9", lg: "4" } },
                [
                  _c(VTextField, {
                    attrs: {
                      filled: "",
                      readonly: "",
                      "hide-details": "auto",
                      dense: "",
                      "append-icon": "mdi-calendar",
                    },
                    model: {
                      value: _vm.expirationDate,
                      callback: function ($$v) {
                        _vm.expirationDate = $$v
                      },
                      expression: "expirationDate",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VRow,
            { staticClass: "mt-2", attrs: { dense: "" } },
            [
              _c(
                VCol,
                { attrs: { cols: "3", lg: "2" } },
                [
                  _c(VSubheader, { staticClass: "font-weight-bold" }, [
                    _vm._v(_vm._s(_vm.$t("form_attrs_use_case.use_case"))),
                  ]),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "9", lg: "4" } },
                [
                  _c(VTextField, {
                    attrs: {
                      filled: "",
                      readonly: "",
                      "hide-details": "auto",
                      dense: "",
                    },
                    model: {
                      value: _vm.useCase.business_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.useCase, "business_name", $$v)
                      },
                      expression: "useCase.business_name",
                    },
                  }),
                ],
                1
              ),
              _vm.businessAreas.length > 0
                ? [
                    _c(
                      VCol,
                      { attrs: { cols: "3", lg: "2" } },
                      [
                        _c(VSubheader, { staticClass: "font-weight-bold" }, [
                          _vm._v(
                            _vm._s(_vm.$t("form_attrs_use_case.business_area"))
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      VCol,
                      { attrs: { cols: "9", lg: "4" } },
                      [
                        _c(VTextField, {
                          attrs: {
                            filled: "",
                            readonly: "",
                            "hide-details": "auto",
                            dense: "",
                            value: _vm.getBusinessArea
                              ? _vm.getBusinessArea.name
                              : "",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _vm.baseExport
            ? _c(
                VRow,
                { staticClass: "mt-2", attrs: { dense: "" } },
                [
                  _c(
                    VCol,
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        VAlert,
                        {
                          staticClass: "mb-0",
                          attrs: { type: "info", outlined: "", dense: "" },
                        },
                        [
                          _vm._v(
                            " Solicitud de exportación base (" +
                              _vm._s(_vm.baseExport.export_type) +
                              "): "
                          ),
                          _c("b", [
                            _vm._v(_vm._s(_vm.baseExport.source_table)),
                          ]),
                          _vm._v(" → "),
                          _c("b", [_vm._v(_vm._s(_vm.baseExport.dest_table))]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.pendingBaseRequest
            ? _c(
                VRow,
                { staticClass: "mt-2", attrs: { dense: "" } },
                [
                  _c(
                    VCol,
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        VAlert,
                        {
                          staticClass: "mb-0",
                          attrs: { type: "info", outlined: "", dense: "" },
                        },
                        [
                          _vm._v(" Solicitud de adición de base sobre "),
                          _c("b", [
                            _vm._v(_vm._s(_vm.pendingBaseRequest.table)),
                          ]),
                          _vm._v(". "),
                          _vm.invalidColumnsText
                            ? [
                                _vm._v(
                                  " Columnas que no cumplen la validación 1:1: "
                                ),
                                _c("b", [
                                  _vm._v(_vm._s(_vm.invalidColumnsText)),
                                ]),
                                _vm._v(
                                  ". Al aprobar se crea la base sin repetir la validación. "
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.baseRequestValidating
            ? _c(
                VRow,
                { staticClass: "mt-2", attrs: { dense: "" } },
                [
                  _c(
                    VCol,
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        VAlert,
                        {
                          staticClass: "mb-0",
                          attrs: { type: "warning", outlined: "", dense: "" },
                        },
                        [
                          _vm._v(" Validación en curso sobre "),
                          _c("b", [_vm._v(_vm._s(_vm.baseRequest.table))]),
                          _vm._v(
                            ". Aún no hay nada que aprobar; vuelve a abrir la solicitud cuando termine. "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.statusReason
            ? _c(
                VRow,
                { staticClass: "mt-2", attrs: { dense: "" } },
                [
                  _c(
                    VCol,
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        VAlert,
                        {
                          staticClass: "mb-0",
                          attrs: { type: "info", outlined: "", dense: "" },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("descripcion.requested_reason")) +
                              ": "
                          ),
                          _c("b", [_vm._v(_vm._s(_vm.statusReason))]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            VRow,
            { staticClass: "mt-2", attrs: { dense: "" } },
            [
              _c(
                VCol,
                { attrs: { cols: "3", lg: "2" } },
                [
                  _c(VSubheader, { staticClass: "font-weight-bold" }, [
                    _vm._v(_vm._s(_vm.$t("form_attrs_use_case.users"))),
                  ]),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "9", lg: "10" } },
                [
                  _c(
                    VChipGroup,
                    _vm._l(_vm.users, function (user) {
                      return _c(VChip, { key: user, staticClass: "mr-1" }, [
                        _vm._v(
                          _vm._s(user) +
                            " " +
                            _vm._s(
                              _vm.isUserOwner(user)
                                ? "(" + _vm.translate("frases.owner") + ")"
                                : ""
                            ) +
                            " "
                        ),
                      ])
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm.useCase.flag_attribute_alert === "1"
                ? _c(
                    VCol,
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        VAlert,
                        { attrs: { type: "error", outlined: "" } },
                        [_vm._v(" " + _vm._s(_vm.useCase.response) + " ")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            VRow,
            { staticClass: "mt-2", attrs: { dense: "" } },
            [
              _c(
                VCol,
                { attrs: { cols: "12" } },
                [
                  _c(VTextField, {
                    staticClass: "pa-1 hidden-xs-only mt-2",
                    attrs: {
                      "prepend-inner-icon": "icon-search",
                      "hide-details": "",
                      filled: "",
                      rounded: "",
                      dense: "",
                      type: "search",
                    },
                    model: {
                      value: _vm.search,
                      callback: function ($$v) {
                        _vm.search = $$v
                      },
                      expression: "search",
                    },
                  }),
                  _c(VDataTable, {
                    key: _vm.keyTable,
                    staticClass: "text-center table-inca",
                    attrs: {
                      responsive: "",
                      dense: "",
                      items: _vm.attributes,
                      headers: _vm.headers,
                      "group-by": "attribute_source_id",
                      search: _vm.search,
                      "hide-default-footer": "",
                      "items-per-page": _vm.pagination.limit,
                      page: _vm.pagination.current,
                    },
                    on: {
                      pagination: function ($event) {
                        _vm.pagination.total = $event.itemsLength
                      },
                      "update:page": function ($event) {
                        return _vm.$set(_vm.pagination, "current", $event)
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item.actions",
                        fn: function (ref) {
                          var item = ref.item
                          return [
                            _c(VCheckbox, {
                              attrs: {
                                disabled:
                                  item.is_partyid === "1" ||
                                  item.attribute_name === "id_sandbox",
                              },
                              model: {
                                value: item.status,
                                callback: function ($$v) {
                                  _vm.$set(item, "status", $$v)
                                },
                                expression: "item.status",
                              },
                            }),
                          ]
                        },
                      },
                      {
                        key: "group.header",
                        fn: function (ref) {
                          var items = ref.items
                          var isOpen = ref.isOpen
                          var toggle = ref.toggle
                          var group = ref.group
                          return [
                            _c(
                              "th",
                              { attrs: { colspan: _vm.headers.length } },
                              [
                                _c(
                                  VCard,
                                  { attrs: { flat: "", color: "transparent" } },
                                  [
                                    _c(
                                      VCardActions,
                                      { staticClass: "mt-2" },
                                      [
                                        _c(
                                          VRow,
                                          { attrs: { dense: "" } },
                                          [
                                            _c(VCol, [
                                              _c(
                                                "div",
                                                [
                                                  _c(
                                                    VIcon,
                                                    {
                                                      attrs: { left: "" },
                                                      on: { click: toggle },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            isOpen
                                                              ? "mdi-minus"
                                                              : "icon-add"
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        items[0]
                                                          .attribute_object_name
                                                      ) +
                                                      " "
                                                  ),
                                                  _c(
                                                    VChip,
                                                    {
                                                      staticClass: "ml-2",
                                                      attrs: { label: "" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(items.length)
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    VTooltip,
                                                    {
                                                      attrs: { bottom: "" },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "activator",
                                                            fn: function (ref) {
                                                              var attrs =
                                                                ref.attrs
                                                              var on = ref.on
                                                              return [
                                                                _c(
                                                                  VChip,
                                                                  _vm._g(
                                                                    _vm._b(
                                                                      {
                                                                        staticClass:
                                                                          "ml-2",
                                                                        attrs: {
                                                                          color:
                                                                            "primary",
                                                                        },
                                                                      },
                                                                      "v-chip",
                                                                      attrs,
                                                                      false
                                                                    ),
                                                                    on
                                                                  ),
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          _vm.getAttributeSource(
                                                                            items[0]
                                                                              .attribute_source_id
                                                                          ).name
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.getAttributeSource(
                                                              items[0]
                                                                .attribute_source_id
                                                            ).description
                                                          )
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ]),
                                            _c(
                                              VCol,
                                              { attrs: { cols: "3" } },
                                              [
                                                _c(
                                                  VRow,
                                                  {
                                                    attrs: {
                                                      dense: "",
                                                      align: "center",
                                                      justify: "end",
                                                    },
                                                  },
                                                  [
                                                    _vm.partitionsByTable &&
                                                    items &&
                                                    items[0] &&
                                                    _vm.partitionsByTable[
                                                      items[0]
                                                        .attribute_object_name
                                                    ] &&
                                                    _vm.partitionsByTable[
                                                      items[0]
                                                        .attribute_object_name
                                                    ].values
                                                      ? _c(VSelect, {
                                                          staticClass:
                                                            "select-periods",
                                                          attrs: {
                                                            label: "Periodo",
                                                            type: "text",
                                                            name: _vm
                                                              .partitionsByTable[
                                                              items[0]
                                                                .attribute_object_name
                                                            ].selection,
                                                            items:
                                                              _vm
                                                                .partitionsByTable[
                                                                items[0]
                                                                  .attribute_object_name
                                                              ].values,
                                                            "item-value": "id",
                                                            "item-text": "name",
                                                            multiple: "",
                                                            "persistent-hint":
                                                              "",
                                                            rules: _vm
                                                              .partitionsByTable[
                                                              items[0]
                                                                .attribute_object_name
                                                            ].values
                                                              ? _vm.rules.period
                                                              : [],
                                                            "prepend-icon":
                                                              "mdi-calendar",
                                                            outlined: "",
                                                            dense: "",
                                                            "single-line": "",
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              return _vm.onChangePartitions(
                                                                items[0]
                                                                  .attribute_object_name
                                                              )
                                                            },
                                                          },
                                                          model: {
                                                            value:
                                                              _vm
                                                                .partitionsByTable[
                                                                items[0]
                                                                  .attribute_object_name
                                                              ].selection,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm
                                                                  .partitionsByTable[
                                                                  items[0]
                                                                    .attribute_object_name
                                                                ],
                                                                "selection",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "partitionsByTable[items[0].attribute_object_name].selection",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                      {
                        key: "item.attribute_source_id",
                        fn: function (ref) {
                          var item = ref.item
                          return [
                            _c(
                              VTooltip,
                              {
                                attrs: { bottom: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function (ref) {
                                        var on = ref.on
                                        var attrs = ref.attrs
                                        return [
                                          _c(
                                            "span",
                                            _vm._g(
                                              _vm._b({}, "span", attrs, false),
                                              on
                                            ),
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getAttributeSource(
                                                    item.attribute_source_id
                                                  ).name
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.getAttributeSource(
                                        item.attribute_source_id
                                      ).description
                                    )
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("pagination-vue", {
                    attrs: { pagination: _vm.pagination },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VRow,
            { staticClass: "mt-2", attrs: { dense: "" } },
            [
              _c(
                VCol,
                { attrs: { cols: "3", lg: "2" } },
                [
                  _c(VSubheader, { staticClass: "font-weight-bold" }, [
                    _vm._v(_vm._s(_vm.$t("form_attrs_use_case.detail"))),
                  ]),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "9", lg: "10" } },
                [
                  _c(VTextarea, {
                    attrs: {
                      filled: "",
                      readonly: "",
                      "hide-details": "auto",
                      dense: "",
                      rows: "2",
                    },
                    model: {
                      value: _vm.useCase.description_business,
                      callback: function ($$v) {
                        _vm.$set(_vm.useCase, "description_business", $$v)
                      },
                      expression: "useCase.description_business",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.getColumnsValidation != ""
            ? _c(
                VRow,
                { staticClass: "mt-2", attrs: { dense: "" } },
                [
                  _c(
                    VCol,
                    { attrs: { cols: "3", lg: "2" } },
                    [
                      _c(VSubheader, { staticClass: "font-weight-bold" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("form_attrs_use_case.columns_validation")
                          )
                        ),
                        _c("span", { staticClass: "error--text" }, [
                          _vm._v("(*)"),
                        ]),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    VCol,
                    { attrs: { cols: "9", lg: "10" } },
                    [
                      _c(VTextarea, {
                        attrs: {
                          "background-color": "#ffab0040",
                          filled: "",
                          readonly: "",
                          "hide-details": "auto",
                          dense: "",
                          rows: "2",
                        },
                        model: {
                          value: _vm.unique_columns_val_text,
                          callback: function ($$v) {
                            _vm.unique_columns_val_text = $$v
                          },
                          expression: "unique_columns_val_text",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            VRow,
            { staticClass: "mt-2", attrs: { dense: "" } },
            [
              _c(
                VCol,
                { attrs: { cols: "3", lg: "2" } },
                [
                  _c(VSubheader, { staticClass: "font-weight-bold" }, [
                    _vm._v(_vm._s(_vm.$t("form_attrs_use_case.response"))),
                  ]),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "9", lg: "10" } },
                [
                  _c(VTextarea, {
                    attrs: {
                      "hide-details": "auto",
                      outlined: "",
                      dense: "",
                      rules: _vm.rules.response,
                      required: "",
                      autofocus: true,
                      rows: "2",
                    },
                    model: {
                      value: _vm.responseRequest,
                      callback: function ($$v) {
                        _vm.responseRequest = $$v
                      },
                      expression: "responseRequest",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }